module.exports = __webpack_public_path__ + "img/face_screaming_in_fear.930b8249.gif";